import { connect, ConnectedProps } from "react-redux";
import { IStoreState } from "../../../../../reducers/types";
import { getPremierCollectionShopChosenProduct } from "../../../../shop/reducer";
import {
  deleteUserPassenger,
  fetchCorpUserPassengers,
  fetchUserPassengers,
  setUserSelectedPassengerIds,
  updateUserPassenger,
} from "../../../actions/actions";
import {
  getUserPassengerCallState,
  getUserPassengers,
  getUserSelectedTravelerId,
  getPremierCollectionBookSelectedAvailabilityCheckInMinimumAge,
} from "../../../reducer";
import { MobileHotelBookPassengerSelection } from "./component";
import { getFromDate } from "../../../../search/reducer";

const mapStateToProps = (state: IStoreState) => ({
  travelers: getUserPassengers(state),
  userPassengerCallState: getUserPassengerCallState(state),
  selectedTravelerId: getUserSelectedTravelerId(state),
  roomsCount: 1,
  chosenProduct: getPremierCollectionShopChosenProduct(state),
  minimumCheckInAge:
    getPremierCollectionBookSelectedAvailabilityCheckInMinimumAge(state),
  checkInDate: getFromDate(state),
});

const mapDispatchToProps = {
  updateUserPassenger,
  setUserSelectedPassengerIds,
  deleteUserPassenger,
  fetchUserPassengers,
  fetchCorpUserPassengers,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type MobileHotelBookPassengerSelectionConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedMobileHotelBookPassengerSelection = connector(
  MobileHotelBookPassengerSelection,
);
